import { CompanySetUpStep } from '@app/models/company/company-set-up-steps/company-set-up-step.model';

export const mockCompanySetUpSteps: CompanySetUpStep[] = [

];